import { useToastStore } from '@/store/toast';

const Toast = () => {
  const { toastData } = useToastStore();
  const { message, icon } = toastData || {};

  return toastData ? (
    <div className="wallet_toast">
      <div className="inner_toast">
        <div className={`ico_wallet ico_toast_${icon}`} />
        <div className="txt_toast">{message}</div>
      </div>
    </div>
  ) : null;
};

export default Toast;
